export { portalContainsElement } from '@fluentui/dom-utilities';
